import { getCollectionUrl, getListingUrl } from '../../collections/hooks/useDiscoveryCollections';

/**
 * Discovery Studio's placements API puts the entity slug in `buttonUrl` when
 * `resultType` is LISTING or COLLECTION (see CalloutsService#toCalloutContent).
 * Link result types already carry a full URL. Hero/Callout buttons treat bare
 * slugs as relative hrefs, so expand them to ecosystem marketplace URLs here.
 */
export function resolveCalloutButtonUrl({
  resultType,
  buttonUrl
}) {
  if (!buttonUrl) {
    return '';
  }

  // Defensive: allow full URLs through (e.g. local mocks that haven't been
  // updated to the slug-in-buttonUrl contract yet).
  if (/^https?:\/\//i.test(buttonUrl)) {
    return buttonUrl;
  }
  if (resultType === 'LISTING') {
    return getListingUrl(buttonUrl);
  }
  if (resultType === 'COLLECTION') {
    return getCollectionUrl(buttonUrl);
  }
  return buttonUrl;
}